/**
 * Garde-fous fin de course côté client : éviter une boucle
 * refresh → saveRaceHistoryAsync → refresh qui plante l’onglet
 * (championnat : persistance serveur ; course libre : une seule tentative).
 */
export function shouldAttemptClientRaceHistorySave(opts: {
  championshipMode: boolean;
  historySaved: boolean;
  historySaveInFlight: boolean;
}): boolean {
  if (opts.championshipMode) return false;
  if (opts.historySaved) return false;
  if (opts.historySaveInFlight) return false;
  return true;
}
